﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX, ReactNode, useCallback} from "react";
import {ButtonKind} from "../ButtonKind";
import buttonTypeClass from "../helpers/buttonTypeClass";
import {Link} from "react-router";

export interface BackButtonProps {
	children?: ReactNode;
	kind?: ButtonKind;
	small?: boolean;
	href?: string;
	className?: string;
	onClick?: () => void;
}

export default function BackButton({children, kind, small, href, className, onClick, ...rest}: BackButtonProps): JSX.Element {
	const finalClassName = className ?? `${buttonTypeClass(kind)}${small ? " form__button--small" : ""}`;

	const handleGoBack = useCallback(function (e: React.MouseEvent<HTMLAnchorElement>) {
		e.preventDefault();
		if (onClick) {
			onClick();
			return;
		}

		if (window.history.length > 1) {
			window.history.back();
		} else {
			window.history.replaceState(null, "", "/");
		}
	}, [onClick]);

	return isNullOrEmpty(href) ?
		<a href="#" onClick={handleGoBack} className={finalClassName} {...rest}>{children}</a> :
		<Link to={href} className={finalClassName} {...rest}>{children}</Link>;
}
